import { Component, Input, OnInit, AfterViewInit, OnDestroy } from '@angular/core';
import { Subscription, forkJoin, Observable } from 'rxjs';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { LWAReason } from '../shared/models/left-without-assistant-reasion.model';
import { LWAReasonService } from '../shared/services/left-without-assistant-reasons.service';
import { Router } from '@angular/router';
import { SortInfo } from 'src/app/shared/models/queryparams/sortinfo.model';
import { PageInfo } from 'src/app/shared/models/queryparams/pageinfo.model';
import { GridComponent, GridDataResult } from '@progress/kendo-angular-grid';
import { SortDescriptor } from '@progress/kendo-data-query';
import { ToastService } from 'src/app/shared/services/toast.service';
import { DirtyFormChecker } from 'src/app/shared/routeguards/DirtyFormChecker';
import { Store } from '@ngrx/store';
import { State } from 'src/app/state/app.state';
import { GetUserPermissionList } from 'src/app/state';
import { UserPermissions } from 'src/app/shared/enums/permissionType';
import { TranslationLoaderFacade } from '../../localization/translation-loader.facade';
import { Language } from 'src/app/master/models/language';
import { MasterLookupService } from 'src/app/master/master-services/master-lookup.service';
import { TranslateService } from '@ngx-translate/core';
import { LocalizedTextModel } from '../../product-services/shared/models/LocalizedTextModel';

 /*
const createFormGroup = (dataItem: LWAReason)  => new FormGroup({
    reason: new FormControl(dataItem.reason, [
        Validators.required, Validators.maxLength(150),
        Validators.pattern(/^((?!<)(?!>)(?![&]).)*$/)
    ])
});
*/

// Language
const createFormGroup = (dataItem: any) => {
    const isEnglish = dataItem.language.languageId === 1;
    return new FormGroup({
      language: new FormControl(dataItem.language, Validators.required),
      reason: new FormControl(
        dataItem.reason, 
        isEnglish
          ? [Validators.required, Validators.maxLength(150), Validators.pattern(/^(?!\s*$)[a-zA-Z0-9 !@#$%^&*()_+\-=\[\]{};':"\\|,.\/?]*$/)] //Allow English characters only - GP
          : [Validators.maxLength(150), Validators.pattern(/^((?!<)(?!>)(?![&]).)*$/)]
      )      
    });
  };


type LWAReasonEvent = { sender: GridComponent, rowIndex: number, dataItem: LWAReason }

@Component({
    selector: 'app-admin-localization-grid',
    templateUrl: './left-without-assistant-reasons-grid.component.html',
    styleUrls: ['./left-without-assistant-reasons-grid.component.scss']
})
export class LWAReasonsGridComponent implements OnInit, OnDestroy, DirtyFormChecker {

    public formGroup: FormGroup | undefined;
    //public gridData: DataResult = process([], this.state);    
    public editedRowIndex: number | undefined;
    public addingNewItem: boolean = false;
    private isItemEditing: boolean = false;
    public openeDeleteconfirmationDialog = false;
    public deletingItem: LWAReason | null = null;
    private subscriptions = new Subscription();
    public userPermissionList: number[] = [];
    public isLWAAlreadyExists = false;
    public languages: Language[] = [];
    

    //Localized Reason fields - GP
    private ReasonLocalizedFieldId = 15;
    private tempReasonLocalizedText: LocalizedTextModel[] = [];

    public data: GridDataResult = {
        total: 0,
        data: [],
    };
    public serviceToRemoveLWAReason: { serviceName: string, serviceId: number | null } =
        {
            serviceName: '',
            serviceId: null
        };
    constructor(public lwareasonService: LWAReasonService,
        private router: Router,
        private store: Store<State>,
        public toastService: ToastService,
        private translationLoaderFacade: TranslationLoaderFacade,
        private lookupService: MasterLookupService,     //GP Added
        private translateService: TranslateService)  { }    //GP Added


    ngOnInit(): void {
        this.store.select(GetUserPermissionList).subscribe((allUserPermissions: number[] | undefined) => {
            if (allUserPermissions == undefined) {
                throw Error("allUserPermissions was undefined! Which was not expected!")
            }
            this.userPermissionList = allUserPermissions;
        });
        this._LoadDataAndAssignDefaults();
        this.loadLanguages();
    }

    ngOnDestroy(): void {
        this.subscriptions.unsubscribe();
    }

    public hasUnsavedData(): boolean {
        return this.editedRowIndex !== undefined;
    }

    /**
     * Add button click event handler
     * append a new item to grid & allow to edit & save
     */
    public addHandler(sender: GridComponent) {
        this.isLWAAlreadyExists = false;
        if (this.editedRowIndex === undefined && !this.isItemEditing) {
            this.closeEditor(sender);
            this.addingNewItem = true;
            let dataItem = new LWAReason();
            dataItem.id = 0;
            dataItem.reason = '';
            //Localization updates
            dataItem.language = this.languages.find(l => l.languageId === 1) || this.languages[0];
            dataItem._prevLanguageId = 1;
            this.tempReasonLocalizedText = [];

            let rowIndex = this.data.data.length;
            this.data.data.splice(rowIndex, 0, dataItem);
            this.editHandler({ sender, rowIndex, dataItem });
        }
    }

    /**
    * Edit button click event handler
    * Edit reason item on selected raw
    */
    public editHandler({ sender, rowIndex, dataItem }: LWAReasonEvent) {
        this.isLWAAlreadyExists = false;
        if (this.isItemEditing === false) {
            this.closeEditor(sender);
            dataItem.isEditing = true;
            dataItem._prevLanguageId = 1;   // GP
            this.formGroup = createFormGroup(dataItem);
            this.tempReasonLocalizedText = dataItem.localizedReason ? [...dataItem.localizedReason] : [];   //GP
            this.editedRowIndex = rowIndex;
            sender.editRow(rowIndex, this.formGroup);
            this.isItemEditing = true;
        }
    }

    /**
     * Cancel button clicked event handler
     * cancel edit/create new reason
     */
    public cancelHandler({ sender, rowIndex }: LWAReasonEvent) {
        if (this.addingNewItem) {
            this.data.data.splice(rowIndex, 1);
            this.addingNewItem = false;
        }
        this.closeEditor(sender, rowIndex);
        this._loadGridDataFromService();
        this.isItemEditing = false;
    }



    /**
     * Save button click event handler
     * Save the changes on server which done on edit box
     */
    public saveHandler({ sender, rowIndex, dataItem }: LWAReasonEvent) {
        var str = dataItem.reason;

        const prevLang = dataItem._prevLanguageId;  //GP
        
            this._saveLocalizedFieldsValues(prevLang, dataItem); //GP
            dataItem.isEditing = false;
            let selectedLWAReason = new LWAReason();

            selectedLWAReason.id = dataItem.id;
            //selectedLWAReason.reason = dataItem.reason;
            selectedLWAReason.reason = this.tempReasonLocalizedText.find(item => item.languageId === 1)?.text || '';//GP
            selectedLWAReason.LocationId = dataItem.LocationId;
            selectedLWAReason.localizedReason = this.tempReasonLocalizedText;//GP
            //selectedLWAReason.reason =  dataItem.reason;//GP
            selectedLWAReason.localizedRowId = dataItem.localizedRowId;//GP
            console.log({ sender, rowIndex, dataItem });//GP

            if (this.addingNewItem) {
                // On New Item Creating Event
                this.createNewReason(selectedLWAReason, sender, rowIndex);
            } else {
                // On Exsisting Item Update Event
                this.updateReason(selectedLWAReason, sender, rowIndex);
            }
    }

    /**
     * delete button clicked event handler
     * delete selected LWA reason item
     */
    public removeHandler({ dataItem }: LWAReasonEvent) {
        if (!this.isItemEditing) {
            var lwaDeleteItem = new LWAReason();
            lwaDeleteItem.id = dataItem.id;
            lwaDeleteItem.reason = dataItem.reason;
            lwaDeleteItem.LocationId = dataItem.LocationId;
            this.onDeleteClick(lwaDeleteItem);
        }
    }

    /**
     * Pop up message on Delete button click event
     * @param clickedRowItem deleting object
     */
    public onDeleteClick(clickedRowItem: LWAReason) {
        this.deletingItem = clickedRowItem;
        this.serviceToRemoveLWAReason = { serviceId: clickedRowItem.id, serviceName: clickedRowItem.reason };
        this.openeDeleteconfirmationDialog = true;
    }

    /**
     * Event handler for closing delete popup dialog
     * @param status 
     */
    public closeDeleteDialog(status: string) {
        this.openeDeleteconfirmationDialog = false;
        if (status === 'yes') {
            if (this.deletingItem == null) {
                throw Error("this.deletingItem was null! Which was not expected!")
            }
            this.lwareasonService.deleteLwaReasons(this.deletingItem)
                .subscribe(() => {
                    this.toastService.showSuccess('_LWA_Deleted_Successfully_Ts_Text_');
                    this._LoadDataAndAssignDefaults();
                },
                    () => this.toastService.showError('_LWA_Deletion_Failed_Ts_Text_'));
        } else {
            this.serviceToRemoveLWAReason = { serviceName: '', serviceId: null };
        }
    }

    public onReasonTextChanged() {
        var str = this.formGroup?.controls.reason.value
        // Check white spaces
        if (!str.replace(/\s/g, '').length) {
            // White spaces found! replace by empty text
            this.formGroup?.controls.reason.setValue("");
        }
    }

    /**
    * Prevent special cheractor pressing
    * @param event key press event
    */
    public keypress(event: any) {
        // Prevent typing spaces as the first character
        if (event.target.selectionStart === 0 && event.which === 32) {
            event.preventDefault();
        }
    }

    public textPasteEvent(event: ClipboardEvent) {
        var pastedText = event.clipboardData?.getData('text');
        if (pastedText?.includes("<") || pastedText?.includes(">") || pastedText?.includes("&")) {
            event.preventDefault();
        }
    }

    /*
    *   Load the grid left without assistant reasons
    */
    private _LoadDataAndAssignDefaults() {
        this.subscriptions.add(
            forkJoin([
                this.lwareasonService.getLwaReasons()
            ]).subscribe({
                next: () => {
                    this._loadGridDataFromService();
                }
            }));
    }

    /**
     *  Load the grid data from the server with
     */
    private _loadGridDataFromService() {
        this.lwareasonService.getLwaReasons()
            .subscribe((response: LWAReason[]) => {
                this.data = {
                    total: response.length,
                    data: response,
                };

                const englishLang = this.languages.find(l => l.languageId === 1);
                response.forEach(item => {
              if (!item.language) {
                item.language = englishLang;
              }
            });
            this.data.data = response; //GP: Add lanaguage to the LWAReason
                
            });
    }



    /**
     * Close editor on the grid
     * @param grid grid
     * @param rowIndex row index
     */
    private closeEditor(grid: GridComponent, rowIndex = this.editedRowIndex) {
        grid.closeRow(rowIndex);
        this.editedRowIndex = undefined;
        this.formGroup = undefined;
    }

    /**
     * Create new reason on server
     * @param reason New Reason object
     */
    private createNewReason(reason: LWAReason, sender: GridComponent, rowIndex: number) {
        this.lwareasonService.createLWAReason(reason)
            .subscribe(() => {
                this._loadGridDataFromService();
                if (sender != null && rowIndex != null) {
                    sender.closeRow(rowIndex);
                }
                this.setValuesToDefault();

                this.toastService.showSuccess('_LWA_Created_Successfully_Ts_Text_');
            }, (reason: any) => {
                if (reason != undefined && reason.error == 'Item Already Exists') {
                    this.isLWAAlreadyExists = true;
                }
                else {

                    this._loadGridDataFromService();
                    this.toastService.showError('_General_Reason_For_Lwa_Failed_Ts_Text_');
                }

            });
    }

    private setValuesToDefault() {
        this.editedRowIndex = undefined;
        this.isItemEditing = false;
        this.addingNewItem = false;
    }

    /**
     * update exsisting LWA reason on server
     * @param reason updating reason object
     */
    private updateReason(reason: LWAReason, sender: GridComponent, rowIndex: number) {
        this.lwareasonService.updateLwaReasons(reason)
            .subscribe(() => {
                this._loadGridDataFromService();
                this.toastService.showSuccess('_General_Changes_Saved_Successfully_Ts_Text_');
                sender.closeRow(rowIndex);
                this.setValuesToDefault();

            }, (reason: any) => {
                if (reason != undefined && reason.error == 'Item Already Exists') {
                    this.isLWAAlreadyExists = true;
                }
                else {

                    this._loadGridDataFromService();
                    this.toastService.showError('_General_Saving_Failed_Ts_Text_');
                }

            });
    }

    public get UserPermissions(): typeof UserPermissions {
        return UserPermissions;
    }


    public saveButtonDisabled(formGroup: any): boolean {
        return formGroup?.invalid == true || formGroup?.pristine == true || this.isEnglishReasonValueEntered() == false;
    }



    /* onLanguageChange(): The previous language's value is saved.
    The new language's value is loaded.
    Validators are adjusted based on the selected language */
    public onLanguageChange(dataItem: LWAReason) {
        const selectedLang = dataItem.language?.languageId;
        const prevLang = dataItem._prevLanguageId;
       this._saveLocalizedFieldsValues(prevLang, dataItem);
    
        // Clear fields and update validators for Spanish
        if (selectedLang === 3) {
          this.formGroup?.controls.reason.clearValidators();
          this.formGroup?.controls.reason.setValidators([
            Validators.maxLength(150),
            Validators.pattern(/^(?!\s*$)((?!<)(?!>)(?![&]).)*$/)
          ]);
          this.formGroup?.controls.reason.updateValueAndValidity();          
          
        } else if (selectedLang === 1) {
          this.formGroup?.controls.reason.setValidators([
            Validators.required,
            Validators.maxLength(150),
            Validators.pattern(/^(?!\s*$)[a-zA-Z0-9 !@#$%^&*()_+\-=\[\]{};':"\\|,.\/?]*$/)  //Allow English characters only - GP
          ]);
          this.formGroup?.controls.reason.updateValueAndValidity();
         
        }
    
        this._changeLocalizedFieldsValues(selectedLang, dataItem);
       dataItem._prevLanguageId = selectedLang || 1;
      }
    
      private loadLanguages() {
        this.lookupService.getLanguages().subscribe({
          next: (languages) => {
            languages.forEach(lan =>{
              if(lan.languageCode == 'en-US') {
                lan.languageName = this.translateService.instant('_General_English_EN_Text_');
              }
              else if(lan.languageCode == 'es-mx') {
                lan.languageName = this.translateService.instant('_General_Spanish_ES_Text_');
              }
            })
            this.languages = languages;
          },
          error: (err) => { console.log(err); }
        });
      }

    
      public languageTrackBy(index: number, item: Language) {
        return item.languageId;
      }
   
      // Save or update localized text values for previous language
      private _saveLocalizedFieldsValues(lanId: number | undefined, reasons: LWAReason) {
        var added = false;
        for (let i = 0; i < this.tempReasonLocalizedText.length; i++) {
          if (this.tempReasonLocalizedText[i].languageId == lanId) {
            this.tempReasonLocalizedText[i].text = this.formGroup?.controls.reason.value ?? "";
            added = true;
          }
        }
        if (!added) {
          this.tempReasonLocalizedText.push({
            localizedTextId: 0,
            localizedRowId: reasons.localizedRowId,
            languageId: lanId,
            localizedFieldId: this.ReasonLocalizedFieldId,
            text: this.formGroup?.controls.reason.value ?? ""
          } as LocalizedTextModel);
        }
        
      }
     
      private _changeLocalizedFieldsValues(newLanguageId: number | undefined, reasons: LWAReason) {
        // Find localized values for the selected language
        const localizedReasons = this.tempReasonLocalizedText.find(l => l.languageId === newLanguageId);
    
        // Assign values to the fields - will set to Localized version of selected language, or blank if it doesn't exist
        this.formGroup?.controls.reason.setValue(localizedReasons ? localizedReasons.text : '');
      }
    
      public isEnglishReasonValueEntered(): boolean {
        return (this.formGroup?.controls.language.value.languageId === 1 && 
          (this.formGroup?.controls.reason.value || this.formGroup?.controls.reason.value.trim() != '')) ||
          (this.tempReasonLocalizedText.find(item => item.languageId === 1)?.text || 
          this.tempReasonLocalizedText.find(item => item.languageId === 1)?.text.trim() != '');
      }   
       
}
